import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Mints a member session on behalf of the calling staff and opens the
 * customer portal in a new tab already authenticated as the target member.
 * Backend enforces admin-only access on this route.
 */
export function useImpersonateMember() {
  const api = useOsApi()

  return useMutation({
    mutationFn: async (memberId: string) => {
      const response = await api.post('/members/:memberId/impersonate', { params: { memberId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    onSuccess: ({ redirectTo }) => {
      window.open(redirectTo, '_blank', 'noopener')
    },
    onError: (err) => {
      toast.error(err instanceof Error ? err.message : 'Failed to impersonate member')
    },
  })
}
